<template>
  <pagelayout>
    <div class="v-btn__content" @click="routeBack">
      <i class="iconfont jiantou-left"></i>
    </div>
    <div class="vc-detail-wrap">
      <div v-if="goPayType == 0">
        <div><img src="@/static/pages/gopay/course1.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/1.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/2.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/3.png" alt="" /></div>
      </div>
      <div v-if="goPayType == 1">
        <div><img src="@/static/pages/gopay/course2.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/1x.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/2x.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/3x.png" alt="" /></div>
      </div>
      <div v-if="goPayType == 2">
        <div><img src="@/static/pages/gopay/course3.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/1c.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/2c.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/3c.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/4c.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/5c.png" alt="" /></div>
      </div>
      <div v-if="goPayType == 3">
        <div><img src="@/static/pages/gopay/course4.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/1d.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/2d.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/3d.png" alt="" /></div>
        <div class="list"><img src="@/static/pages/gopay/4d.png" alt="" /></div>
      </div>
    </div>
  </pagelayout>
</template>

<script>
import appConfigMixins from "@c/mixins/appConfig.mixins";
import Appbar from "@c/layout/Appbar";
export default {
  mixins: [appConfigMixins],
  components: {
    Appbar,
  },
  data() {
    return {
      goPayType: 0,
    };
  },
  created() {
    this.init();
  },
  methods: {
    routeBack({ numb = -1 }) {
      const currHref = window.location.href;
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.go(numb);
        setTimeout(() => {
          if (window.location.href == currHref) {
            if (window.android) {
              window.android.goBack();
            }
            this.$router.push({ path: "/" });
          }
        }, 100);
      }
    },
    init() {
      switch (this.$route.query.type) {
        case "recharge":
          this.goPayType = 0;
          break;
        case "pickup":
          this.goPayType = 1;
          break;
        case "buymoney":
          this.goPayType = 2;
          break;
        case "sellmoney":
          this.goPayType = 3;
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.v-btn__content {
  height: 40px;
  background: #fff;
  padding-left: 10px;
}
.vc-detail-wrap {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #fff;
  .list {
    border-bottom: 1px solid #eee;
    padding-top: 30px;
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
